import {
	INITIAL_LOGIN_REQUEST,
	FINAL_LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
	LOGOUT_SUCCESS,
	LOGOUT_ERROR,
	UPDATE_NOTIFICATIONS,
	UPDATE_FILTER,
	CHANGE_ESTATES,
	UPDATE_CUSTOMER_SCREENS,
	UPDATE_DASHBOARD,
	UPDATE_DASHBOARD_FILTER,
	INITIAL_LOGOUT_REQUEST,
	FINAL_LOGOUT_REQUEST,
	UPDATE_USER_ESTATES,
	UPDATE_USE_ESTATE_PARENT,
	UPDATE_ESTATES_PARENTS_ESTATES,
	CLEAR_SURVEY,
	UPDATE_FETCHING_GLOBAL,
	UPDATE_USER,
	CHANGE_SEASON,
} from "../types/auth.types";

const initialState = {
	token: null,
	user: null,
	error: null,
	survey: null,
	season: null,
	isFetching: false,
	isFetchingLogout: false,
	isFetchingGlobal: false,
	isFetchingGlobalMessage: "",
	authRedirectPath: "/",
	screens_option: [],
	notifications: [],
	dashboard: [],
	customers: [],
	business_id: "",
	aptitudes_id: "",
	initial_date: "",
	final_date: "",
	filter: {
		estate_parent_id: "",
		estate_id: "",
		type_currency: "USD",
		search: "",
		application: "",
		parameter: "",
		unit_measurement: "kg_l",
	},
};

function auth(state = initialState, action) {
	switch (action.type) {
		case INITIAL_LOGIN_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};
		case INITIAL_LOGOUT_REQUEST:
			return {
				...state,
				isFetchingLogout: true,
				user: null,
				error: null,
			};
		case FINAL_LOGOUT_REQUEST:
			return {
				...state,
				user: null,
				isFetchingLogout: false,
				error: null,
			};
		case FINAL_LOGIN_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				isFetching: false,
				user: action.payload.user,
				survey: action.payload.survey,
				season: action.payload.season,
				customers: action.payload.customers,
				token: action.payload.token,
				screens_option: action.payload.screens_option,
				notifications: action.payload.notifications,
				dashboard: action.payload.dashboard,
				filter: action.payload.filter,
			};
		case LOGIN_ERROR:
			return {
				...state,
				isFetching: false,
				user: null,
				survey: null,
				season: null,
				token: false,
				customers: [],
				screens_option: [],
				notifications: [],
				dashboard: [],
			};
		case LOGOUT_SUCCESS:
			return {
				...state,
				isFetching: false,
				isFetchingLogout: false,
				user: false,
				survey: null,
				season: null,
				customers: [],
				token: false,
				screens_option: [],
				notifications: [],
				dashboard: [],
			};
		case LOGOUT_ERROR:
			return {
				...state,
				isFetching: false,
				isFetchingLogout: false,
				user: action.payload.error,
			};
		case UPDATE_NOTIFICATIONS:
			return {
				...state,
				notifications: action.payload.notifications,
			};
		case UPDATE_FILTER:
			return {
				...state,
				filter: action.payload.filter,
			};
		case CHANGE_ESTATES:
			return {
				...state,
				user: {
					...state.user,
					customer: {
						...state.user.customer,
						estates: action.payload.estates,
					},
				},
			};
		case UPDATE_CUSTOMER_SCREENS:
			return {
				...state,
				user: {
					...state.user,
					customer: {
						...state.user.customer,
						customer_screens: action.payload.customer_screens,
					},
				},
			};
		case UPDATE_USER_ESTATES:
			action.payload.estates_parents = action.payload.estates_parents.map((item) => {
				return {
					...item,
					show_estate: item.show_estate === "1" ? true : false,
				};
			});

			return {
				...state,
				filter: {
					...state.filter,
					estate_parent_id: action.payload.estates_parents.map((item) => item.value).join(","),
					estate_id: action.payload.estates.map((item) => item.value).join(","),
				},
				user: {
					...state.user,
					estates_parents: action.payload.estates_parents,
					estates: action.payload.estates,
				},
			};
		case UPDATE_DASHBOARD:
			return {
				...state,
				dashboard: action.payload.dashboard,
			};
		case UPDATE_DASHBOARD_FILTER:
			return {
				...state,
				business_id: action.payload.business_id ? action.payload.business_id : "",
				aptitudes_id: action.payload.aptitudes_id ? action.payload.aptitudes_id : "",
				initial_date: action.payload.initial_date ? action.payload.initial_date : "",
				final_date: action.payload.final_date ? action.payload.final_date : "",
			};
		case UPDATE_USE_ESTATE_PARENT:
			return {
				...state,
				user: {
					...state.user,
					customer: {
						...state.user.customer,
						use_estates_parents: action.payload.use_estate_parent,
					},
				},
			};
		case UPDATE_ESTATES_PARENTS_ESTATES:
			return {
				...state,
				user: {
					...state.user,
					estates: action.payload.estates,
					estates_parents: action.payload.estates_parents,
				},
				filter: {
					...state.filter,
					estate_parent_id: action.payload.estates_parents.map((item) => item.value).join(","),
					estate_id: action.payload.estates.map((item) => item.value).join(","),
				},
			};
		case CLEAR_SURVEY:
			return {
				...state,
				survey: null,
			};
		case UPDATE_FETCHING_GLOBAL:
			return {
				...state,
				isFetchingGlobal: action.payload.isFetchingGlobal,
				isFetchingGlobalMessage: Object.prototype.hasOwnProperty.call(action.payload, "isFetchingGlobalMessage")
					? action.payload.isFetchingGlobalMessage
					: state.isFetchingGlobalMessage,
			};
		case UPDATE_USER:
			return {
				...state,
				user: action.payload.user,
			};
		case CHANGE_SEASON:
			return {
				...state,
				season: action.payload.season,
			};
		default:
			return state;
	}
}

export default auth;
